import React from "react";
import { typography } from "../tokens";

export function FilterTabs({ items, value, onChange, labelFn }) {
  return (
    <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
      {items.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`px-3 py-1.5 rounded-md transition-all ${
            value === item ? "bg-white shadow text-gray-800" : "text-gray-500 hover:text-gray-700"
          }`}
          style={{ fontSize: "0.8rem" }}
        >
          {labelFn ? labelFn(item) : item}
        </button>
      ))}
    </div>
  );
}

export function FilterTabLabel({ children }) {
  return (
    <p className="px-3 py-1 text-gray-400" style={{ fontSize: "0.68rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>
      {children}
    </p>
  );
}
